import { NgModule } from '@angular/core';
import { BusinessProcessGraphComponent } from './components/business-process-graph/business-process-graph.component';
import { MaterialModule } from '../material/material.module';

@NgModule({
  declarations: [BusinessProcessGraphComponent],
  exports: [BusinessProcessGraphComponent],
  imports: [MaterialModule],
  providers: [],
})
export class BusinessProcessModule {}
